 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1LINYI from '@/components/0_chapter1linyi'
 import A_CHAPTER2PLANEPHOTONPROCESSOR from '@/components/1_chapter2planephotonprocessor'
 import A_CHAPTER3THEMAGICALMAGISTER from '@/components/2_chapter3themagicalmagister'
 import A_CHAPTER4YANYUANHOLYGRIMOIREACADEMY from '@/components/3_chapter4yanyuanholygrimoireacademy'
 import A_CHAPTER5AMAZINGTALENT from '@/components/4_chapter5amazingtalent'
 import A_CHAPTER6PRIMARYPERMISSIONS from '@/components/5_chapter6primarypermissions'
 import A_CHAPTER7SPIRITUALGODSECT from '@/components/6_chapter7spiritualgodsect'
 import A_CHAPTER8MANYPEOPLEARESTUPID from '@/components/7_chapter8manypeoplearestupid'
 import A_CHAPTER9SIMPLE from '@/components/8_chapter9simple'
 import A_CHAPTER10CANONICALTECHNIQUE from '@/components/9_chapter10canonicaltechnique'
 import A0_CHAPTER11TRAININGPLAN from '@/components/10_chapter11trainingplan'
 import A1_CHAPTER12DONGMENXIULING from '@/components/11_chapter12dongmenxiuling'
 import A2_CHAPTER13SPIRITUALTIERHIGHRANKTECHNIQUEGREENLOTUS from '@/components/12_chapter13spiritualtierhighranktechniquegreenlotus'
 import A3_CHAPTER14SIGNUP from '@/components/13_chapter14signup'
 import A4_CHAPTER15DIVINEINSCRIPTIONSTAOMARK from '@/components/14_chapter15divineinscriptionstaomark'
 import A5_CHAPTER16DIVINEDARKSEAL from '@/components/15_chapter16divinedarkseal'
 import A6_CHAPTER17CLEARANCE from '@/components/16_chapter17clearance'
 import A7_CHAPTER18DECISIVEPARTI from '@/components/17_chapter18decisiveparti'
 import A8_CHAPTER19DECISIVEPARTII from '@/components/18_chapter19decisivepartii'
 import A9_CHAPTER20GONGSUNLAN from '@/components/19_chapter20gongsunlan'
 import A0_CHAPTER21THEVILLAINCOMPLAINSFIRST from '@/components/20_chapter21thevillaincomplainsfirst'
 import A1_CHAPTER22DOMINEERINGARROGANT from '@/components/21_chapter22domineeringarrogant'
 import A2_CHAPTER23YONGCHUNMARTIALARTSSCHOOL from '@/components/22_chapter23yongchunmartialartsschool'
 import A3_CHAPTER24FRIENDS from '@/components/23_chapter24friends'
 import A4_CHAPTER25SWORDFINGERFIRST from '@/components/24_chapter25swordfingerfirst'
 import A5_CHAPTER26OCCULTRING from '@/components/25_chapter26occultring'
 import A6_CHAPTER27LEVELFOURANDTHECHALLENGE from '@/components/26_chapter27levelfourandthechallenge'
 import A7_CHAPTER28BLOODPRINTPARTI from '@/components/27_chapter28bloodprintparti'
 import A8_CHAPTER29BLOODPRINTPARTII from '@/components/28_chapter29bloodprintpartii'
 import A9_CHAPTER30PRELUDE from '@/components/29_chapter30prelude'
 import A0_CHAPTER31START from '@/components/30_chapter31start'
 import A1_CHAPTER32INITIALAPPEARANCE from '@/components/31_chapter32initialappearance'
 import A2_CHAPTER33SHOCK from '@/components/32_chapter33shock'
 import A3_CHAPTER34MARTIALARTDUALCULTIVATION from '@/components/33_chapter34martialartdualcultivation'
 import A4_CHAPTER35EASYTWOWHEELS from '@/components/34_chapter35easytwowheels'
 import A5_CHAPTER36DEATHWATERPARTI from '@/components/35_chapter36deathwaterparti'
 import A6_CHAPTER37DEATHWATERPARTII from '@/components/36_chapter37deathwaterpartii'
 import A7_CHAPTER38FIRST from '@/components/37_chapter38first'
 import A8_CHAPTER39LOTUSBLOOMINGSTEPBYSTEPWORLDBYWORLDPARTI from '@/components/38_chapter39lotusbloomingstepbystepworldbyworldparti'
 import A9_CHAPTER40LOTUSBLOOMINGSTEPBYSTEPWORLDBYWORLDPARTII from '@/components/39_chapter40lotusbloomingstepbystepworldbyworldpartii'
 import A0_CHAPTER41LEVELEIGHT from '@/components/40_chapter41leveleight'
 import A1_CHAPTER42CHANGESINTHESOULSPACE from '@/components/41_chapter42changesinthesoulspace'
 import A2_CHAPTER43RAKASHA from '@/components/42_chapter43rakasha'
 import A3_CHAPTER44MORTALLEVELDIVINEINSCRIPTIONISTROSSI from '@/components/43_chapter44mortalleveldivineinscriptionistrossi'
 import A4_CHAPTER45ANDRE from '@/components/44_chapter45andre'
 import A5_CHAPTER46SECONDSTEPTRAININGPLAN from '@/components/45_chapter46secondsteptrainingplan'
 import A6_CHAPTER47PURIFYINGFIREOFBLUELOTUS from '@/components/46_chapter47purifyingfireofbluelotus'
 import A7_CHAPTER48THECULTIVATIONOFTHESCHOLARSREALM from '@/components/47_chapter48thecultivationofthescholarsrealm'
 import A8_CHAPTER49COMPREHENSION from '@/components/48_chapter49comprehension'
 import A9_CHAPTER50SHOCK from '@/components/49_chapter50shock'
 import A0_CHAPTER51PRACTICE from '@/components/50_chapter51practice'
 import A1_CHAPTER52MAKER from '@/components/51_chapter52maker'
 import A2_CHAPTER53SOULASCENSIONBERSERK from '@/components/52_chapter53soulascensionberserk'
 import A3_CHAPTER54OPENAGAIN from '@/components/53_chapter54openagain'
 import A4_CHAPTER55NEWSAGEPARTI from '@/components/54_chapter55newsageparti'
 import A5_CHAPTER56NEWSAGEPARTII from '@/components/55_chapter56newsagepartii'
 import A6_CHAPTER57NINEGRADEGOLDENLOTUS from '@/components/56_chapter57ninegradegoldenlotus'
 import A7_CHAPTER58LINYISSTRENGTH from '@/components/57_chapter58linyisstrength'
 import A8_CHAPTER59LESSONSFORTHERESTOFYOURLIFE from '@/components/58_chapter59lessonsfortherestofyourlife'
 import A9_CHAPTER60DIVINEREMAINS from '@/components/59_chapter60divineremains'
 import A0_CHAPTER61ALIFEOFDEFEAT from '@/components/60_chapter61alifeofdefeat'
 import A1_CHAPTER62UNEXPECTEDRESULT from '@/components/61_chapter62unexpectedresult'
 import A2_CHAPTER63OUTSTANDINGVICTORY from '@/components/62_chapter63outstandingvictory'
 import A3_CHAPTER64THEMINDOFTHEEMPIRE from '@/components/63_chapter64themindoftheempire'
 import A4_CHAPTER65UNDERCURRENT from '@/components/64_chapter65undercurrent'
 import A5_CHAPTER66PRELUDESALAZAR from '@/components/65_chapter66preludesalazar'
 import A6_CHAPTER67BARBARIANCOWSEAL1 from '@/components/66_chapter67barbariancowseal1'
 import A7_CHAPTER68BARBARIANCOWSEAL2 from '@/components/67_chapter68barbariancowseal2'
 import A8_CHAPTER69JESSICA from '@/components/68_chapter69jessica'
 import A9_CHAPTER70PRAIRIEFIRE from '@/components/69_chapter70prairiefire'
 import A0_CHAPTER71HUBAISEAL from '@/components/70_chapter71hubaiseal'
 import A1_CHAPTER72LISTOFGENIUSES from '@/components/71_chapter72listofgeniuses'
 import A2_CHAPTER73SMALLSECTSLIST from '@/components/72_chapter73smallsectslist'
 import A3_CHAPTER74THEARCANAOFTHEANCIENTERA from '@/components/73_chapter74thearcanaoftheancientera'
 import A4_CHAPTER75GREENLIGHTSWORD1 from '@/components/74_chapter75greenlightsword1'
 import A5_CHAPTER76GREENLIGHTSWORD2 from '@/components/75_chapter76greenlightsword2'
 import A6_CHAPTER77TOWNBROOK from '@/components/76_chapter77townbrook'
 import A7_CHAPTER78DECEIVINGPOTENTIALVALUE from '@/components/77_chapter78deceivingpotentialvalue'
 import A8_CHAPTER79QIANLIEXIAN from '@/components/78_chapter79qianliexian'
 import A9_CHAPTER80SWORDINTENTCROSSING from '@/components/79_chapter80swordintentcrossing'
 import A0_CHAPTER81TAOBAO from '@/components/80_chapter81taobao'
 import A1_CHAPTER82GAMBLING from '@/components/81_chapter82gambling'
 import A2_CHAPTER83ACTIVATINGTHERUINSOFTHEDIVINEART from '@/components/82_chapter83activatingtheruinsofthedivineart'
 import A3_CHAPTER84MANIA from '@/components/83_chapter84mania'
 import A4_CHAPTER85PALACEINTHEDEPTHSOFTHEANCIENTCITY from '@/components/84_chapter85palaceinthedepthsoftheancientcity'
 import A5_CHAPTER86CONFLICT from '@/components/85_chapter86conflict'
 import A6_CHAPTER87FIGHTING from '@/components/86_chapter87fighting'
 import A7_CHAPTER88BEHEADING from '@/components/87_chapter88beheading'
 import A8_CHAPTER89FIRECONTROLOLDMAN from '@/components/88_chapter89firecontrololdman'
 import A9_CHAPTER90CENTRALZONE from '@/components/89_chapter90centralzone'
 import A0_CHAPTER91COMPREHENSIONSTONETABLET from '@/components/90_chapter91comprehensionstonetablet'
 import A1_CHAPTER92CLOSETOTHESTONETABLET from '@/components/91_chapter92closetothestonetablet'
 import A2_CHAPTER93DESOLATEREALM from '@/components/92_chapter93desolaterealm'
 import A3_CHAPTER94DIVINELEVELEXPERT from '@/components/93_chapter94divinelevelexpert'
 import A4_CHAPTER95CONSPIRACY from '@/components/94_chapter95conspiracy'
 import A5_CHAPTER96ESCAPE from '@/components/95_chapter96escape'
 import A6_CHAPTER97THESTRENGTHOFAPEAKLEVELPOWERHOUSE from '@/components/96_chapter97thestrengthofapeaklevelpowerhouse'
 import A7_CHAPTER98VIBRATIONS from '@/components/97_chapter98vibrations'
 import A8_CHAPTER99AREVERSALOFPOWER from '@/components/98_chapter99areversalofpower'
 import A9_CHAPTER100BEHINDCLOSEDDOORS from '@/components/99_chapter100behindcloseddoors'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1linyi",
 			"name" : "0_chapter1linyi",
 			"component" : A_CHAPTER1LINYI
 		},
 		{
 			"path" : "/1_chapter2planephotonprocessor",
 			"name" : "1_chapter2planephotonprocessor",
 			"component" : A_CHAPTER2PLANEPHOTONPROCESSOR
 		},
 		{
 			"path" : "/2_chapter3themagicalmagister",
 			"name" : "2_chapter3themagicalmagister",
 			"component" : A_CHAPTER3THEMAGICALMAGISTER
 		},
 		{
 			"path" : "/3_chapter4yanyuanholygrimoireacademy",
 			"name" : "3_chapter4yanyuanholygrimoireacademy",
 			"component" : A_CHAPTER4YANYUANHOLYGRIMOIREACADEMY
 		},
 		{
 			"path" : "/4_chapter5amazingtalent",
 			"name" : "4_chapter5amazingtalent",
 			"component" : A_CHAPTER5AMAZINGTALENT
 		},
 		{
 			"path" : "/5_chapter6primarypermissions",
 			"name" : "5_chapter6primarypermissions",
 			"component" : A_CHAPTER6PRIMARYPERMISSIONS
 		},
 		{
 			"path" : "/6_chapter7spiritualgodsect",
 			"name" : "6_chapter7spiritualgodsect",
 			"component" : A_CHAPTER7SPIRITUALGODSECT
 		},
 		{
 			"path" : "/7_chapter8manypeoplearestupid",
 			"name" : "7_chapter8manypeoplearestupid",
 			"component" : A_CHAPTER8MANYPEOPLEARESTUPID
 		},
 		{
 			"path" : "/8_chapter9simple",
 			"name" : "8_chapter9simple",
 			"component" : A_CHAPTER9SIMPLE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js